module.exports = __webpack_public_path__ + "media/images/postmates-26dd595a45593bc54c21031f5ca4a10a.svg";